import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

interface FeaturesInterface {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const ExtraFeatures = ({ features }: { features: FeaturesInterface[] }) => {
  const { t } = useTranslation('entity');

  return (
    <Container>
      <h3 className="headline">{t('only_in_modon')}</h3>
      <div className="features-container">
        {features.map(feature => (
          <div key={feature.id} className="feature-item">
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-info">
              <span>{feature.title}</span>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .features-container {
    display: flex;
    flex-direction: row;
    gap: 24px;

    .feature-item {
      display: flex;
      flex-direction: row;
      gap: 10px;
      max-width: 190px;

      .feature-icon {
        width: 26px;
        height: 26px;
      }
      .feature-info {
        display: flex;
        flex-direction: column;
        gap: 4px;

        span {
          color: #2c3138;
          font-family: materialMedium;
          font-size: 18px;
          line-height: 150%;
        }
        p {
          color: #656565;
          font-family: materialLight;
          font-size: 14px;
          line-height: 150%;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .features-container {
      flex-direction: column;
      gap: 16px;

      .feature-item {
        gap: 12px;
        max-width: 100%;

        .feature-icon {
          width: 24px;
          height: 24px;
        }

        .feature-info {
          span {
            font-size: 14px;
          }
          p {
            color: #3d3d3d;
            font-size: 12px;
          }
        }
      }
    }
  }
`;

export default ExtraFeatures;
